import config from 'config';
import { isoDate } from 'utils/LocalDateTimeHelper';

const LOAD_MATCHES = 'football/dailyMatches/LOAD_MATCHES';
const LOAD_MATCHES_SUCCESS = 'football/dailyMatches/LOAD_MATCHES_SUCCESS';
const LOAD_MATCHES_FAIL = 'football/dailyMatches/LOAD_MATCHES_FAIL';
const LOAD_MATCHES_RESET = 'football/dailyMatches/LOAD_MATCHES_RESET';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_MATCHES:
      return {
        ...state,
        loading: true
      };
    case LOAD_MATCHES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        matches: action.result,
        date: action.date
      };
    }
    case LOAD_MATCHES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    case LOAD_MATCHES_RESET:
      return {
        ...state,
        loading: false,
        loaded: false
      };
    default:
      return state;
  }
}

export function areMatchesLoaded({ football: { dailyMatches: { loading, loaded, date } } }, givenDate) {
  return (loading || loaded) && (date == givenDate || date == isoDate(new Date()));
}

export function resetMatchesLoaded() {
  return {
    type: LOAD_MATCHES_RESET
  }
}

export function loadMatches(date, resultsOnly = false) {
  if (!date) {
    date = isoDate(new Date());
  }

  const params = {
    match_date: date
  };

  if (resultsOnly) {
    params.results_only = true;
  }

  return {
    types: [LOAD_MATCHES, LOAD_MATCHES_SUCCESS, LOAD_MATCHES_FAIL],
    promise: client => client.get(config.api.football.dailyMatches, {params}),
    date
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/dailyMatches.js